<template>
  <v-container fluid>
    <v-layout
      text-center
      wrap
    >
      <v-flex xs12>
        <img src="@/assets/main.png" width="180" height="200" />
        <h1 class="display-2 font-weight-bold">
          VRテレビ電話
        </h1>
      </v-flex>

      <v-flex xs12>
        <v-container grid-list-xl>
          <v-layout row wrap align-center>
            <v-flex xs12 md4>
              <v-card flat class="transparent">
                <v-card-text class="text-center">
                  <v-icon x-large class="blue--text text--lighten-2">mdi-monitor-cellphone-star</v-icon>
                </v-card-text>
                <v-card-title primary-title class="layout justify-center">
                  <div class="headline text-center">STEP 1</div>
                </v-card-title>
                <v-card-text>
                  このサイトはVR風の映像を2台のスマホで遊ぶために作ったものだ。
                  横向き用に作っているので、縦画面だったら横向きにしてリロードしてくださいまし。
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12 md4>
              <v-card flat class="transparent">
                <v-card-text class="text-center">
                  <v-icon x-large class="blue--text text--lighten-2">mdi-flash</v-icon>
                </v-card-text>
                <v-card-title primary-title class="layout justify-center">
                  <div class="headline">STEP 2</div>
                </v-card-title>
                <v-card-text>
                  パスワードが表示されていると思うので、それを通信したいスマホに入力しよう。
                  相手にパスワードを入力してもらったら少し待ってくれ。
                  もしパスワードが表示されていなかったら非対応だ、残念。
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12 md4>
              <v-card flat class="transparent">
                <v-card-text class="text-center">
                  <v-icon x-large class="blue--text text--lighten-2">mdi-virtual-reality</v-icon>
                </v-card-text>
                <v-card-title primary-title class="layout justify-center">
                  <div class="headline text-center">STEP3</div>
                </v-card-title>
                <v-card-text>
                  通信ができたらあとは自由に遊んでほしい。
                  基本的には片方のスマホで撮影して、もう片方をゴーグルにセットして遊ぶ形になる。
                  簡易的なVRだが工夫次第で遊び方は無限大だ!!
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>

      <v-flex xs12>
        <v-col cols="12">
          <v-card ref="form">
            <v-card-text>
              <v-text-field
                v-model="callId"
                label="相手のパスワードを入力してください"
                placeholder=""
                required
              ></v-text-field>
            </v-card-text>
            <v-card-actions>
              パスワード： <span class="font-weight-black">{{ peerId }}</span>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="call()">通信</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-flex>

      <v-flex xs12>
        <h2 class="display-2 font-weight-bold">
        </h2>
      </v-flex>

      <v-flex xs12 class="video">
        <v-row>
          <v-col>
            <video id="left-video" autoplay playsinline></video>
          </v-col>
          <v-col>
            <video id="right-video" autoplay playsinline></video>
          </v-col>
        </v-row>
      </v-flex>



    </v-layout>
  </v-container>
</template>

<script>
import Peer from 'skyway-js'

export default {
  name: 'HelloWorld',

  data() {
    return {
      localStream: null,
      peer: null,
      existingCall: null,
      peerId: "",
      callId: ""
    }
  },
  created() {
    this.initNavigate()
    this.initPeer()
  },
  methods: {
    initPeer() {
      this.peer = new Peer({
        key: '05fa91af-7fbc-40a5-b0a3-ab59faab674b',
        debug: 3
      });

      const self = this
      this.peer.on('call', function(call){
        call.answer(self.localStream);
        self.setupCallEventHandlers(call);
      });
      this.peer.on('open', function(){
        self.peerId = self.peer.id
      })
    },
    initNavigate() {
      const self = this
      var medias = {video: {}, audio: false }
      if(navigator.userAgent.match(/(iPhone|iPod|Android.*Mobile)/i)){
        // スマホの場合は外側カメラを使用するようにする
        medias.video = { facingMode: { exact: "environment" } }
      }
      navigator.mediaDevices.getUserMedia(medias)
        .then(function (stream) {
          self.localStream = stream;
        })
    },
    call() {
      const call = this.peer.call(this.callId, this.localStream);
      this.setupCallEventHandlers(call)
    },
    setupCallEventHandlers(call) {
      if (this.existingCall) {
        this.existingCall.close();
      }
      this.existingCall = call;

      const self = this
      navigator.mediaDevices.getUserMedia({video: true, audio: false})
      call.on('stream', function(stream){
        self.addVideo(call,stream);
      });
    },
    closeCall() {
      this.existingCall.close();
    },
    addVideo(call, stream) {
      document.getElementById("left-video").srcObject = stream;
      document.getElementById("right-video").srcObject = stream;
    },
  }
}

</script>

<style scoped>
video {
  padding: 0;
  width: 100%;
  height: auto;
  min-height: 100vh;
  background-color: #eee;
}

.video .col {
  padding: 0;
}
</style>